import { getBookingReportChecklist } from "../../Booking/BookingReportChecklistUtils";

export const FINISHED_SLEEP_STUDY_STATUSES = [
  "Doctor Scored",
  "Post-Consult",
  "Sale Follow Up",
  "Sale Follow Up [MC]",
  "Sale Follow Up [STM]",
  "Ready for CPAP Purchase",
  "Ship",
  "Ship [CPAP Purchase]",
  "Ship [CPAP Trial]",
  "Ship [CPAP Rental]",
  "Ship [No CPAP]",
];

export const FINISHED_REPORT_CHECK_PASSED_FILTER =
  "All finished cases with report check passed";
export const FINISHED_REPORT_CHECK_NOT_PASSED_FILTER =
  "All finished cases with report check not passed";

export const SLEEP_STUDY_REPORT_EXPORT_TITLE = "Report";
export const SLEEP_STUDY_REPORT_EXPORT_HEADERS = [
  "Study Report",
  "Medical Cert",
  "Trial Report",
];
export const SLEEP_STUDY_PATIENT_CONTACT_EXPORT_HEADERS = [
  "วันเกิด",
  "เบอร์โทรศัพท์",
];

const getBookingProps = (booking = {}) =>
  (booking && booking.extendedProps) || booking || {};

const normalizeExportValue = (value) =>
  String(value === undefined || value === null ? "" : value).trim();

export const getSleepStudyExportPhone = (
  patientData = {},
  booking = {},
) => {
  const bookingProps = getBookingProps(booking);

  return (
    [patientData.mobile, patientData.telephone, bookingProps.phone]
      .map(normalizeExportValue)
      .find(Boolean) || ""
  );
};

export const getSleepStudyPatientContactExportCells = (booking = {}) => {
  const bookingProps = getBookingProps(booking);

  return [
    normalizeExportValue(bookingProps.dob),
    normalizeExportValue(bookingProps.phone),
  ];
};

const hasReportPart = (checklist, key) =>
  checklist.parts.some(
    (part) =>
      part.key === key && Array.isArray(part.files) && part.files.length > 0,
  );

export const isFinishedSleepStudyStatus = (status) =>
  FINISHED_SLEEP_STUDY_STATUSES.includes(String(status || "").trim());

export const isFinishedSleepStudyExportFilter = (filter) =>
  [
    "Only finished cases",
    FINISHED_REPORT_CHECK_PASSED_FILTER,
    FINISHED_REPORT_CHECK_NOT_PASSED_FILTER,
  ].includes(filter);

export const getFinishedSleepStudyExcludedStatuses = (statuses = []) =>
  (Array.isArray(statuses) ? statuses : []).filter(
    (status) => !FINISHED_SLEEP_STUDY_STATUSES.includes(status),
  );

export const getSleepStudyReportExportCheck = (booking = {}, reports = []) => {
  const bookingProps = getBookingProps(booking);
  const checklist = getBookingReportChecklist(reports, {
    hn: bookingProps.hn,
    node: bookingProps.node,
    healthInsurance: bookingProps.healthInsurance,
  });

  return {
    isReady: checklist.isReady,
    sleepStudyReport: hasReportPart(checklist, "sleepStudyReport"),
    medicalCertificate: hasReportPart(checklist, "medicalCertificate"),
    trialReport: hasReportPart(checklist, "trialReport"),
  };
};

export const getSleepStudyReportExportCells = (reportCheck = {}) => [
  reportCheck.sleepStudyReport ? "✅" : "",
  reportCheck.medicalCertificate ? "✅" : "",
  reportCheck.trialReport ? "✅" : "",
];

export const shouldIncludeSleepStudyExportBooking = (
  booking = {},
  selectedFilter = "",
) => {
  const bookingProps = getBookingProps(booking);

  if (!isFinishedSleepStudyExportFilter(selectedFilter)) {
    return true;
  }

  if (!isFinishedSleepStudyStatus(bookingProps.status)) {
    return false;
  }

  const reportCheck = booking.reportCheck || {};

  if (selectedFilter === FINISHED_REPORT_CHECK_PASSED_FILTER) {
    return reportCheck.isReady === true;
  }

  if (selectedFilter === FINISHED_REPORT_CHECK_NOT_PASSED_FILTER) {
    return reportCheck.isReady === false;
  }

  return true;
};
